module.exports = __webpack_public_path__ + "img/Abracaf.51bfb2cc.png";